const profile = [
  {
    path: "/profile",
    name: "/profile",
    redirect: { name: "/profile/details/account" },
    meta: { requiresAuth: true, layout: "Main", title: "Profile" },
  },
  {
    path: "/profile/details/payment",
    name: "/profile/details/payment",
    component: () => import("@/views/profile/PaymentPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "Main",
      title: "Profile | Payment",
    },
  },
  {
    path: "/profile/details/shipping",
    name: "/profile/details/shipping",
    component: () => import("@/views/profile/ShippingPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "Main",
      title: "Profile | Shipping",
    },
  },
  {
    path: "/profile/invoices",
    name: "/profile/invoices",
    component: () => import("@/views/profile/InvoicesPage.vue"),
    props: (route) => ({
      params: {
        page: parseInt(route.query.page) || 1,
        sortOrder: route.query.sortOrder || "DESC",
      },
    }),
    meta: {
      requiresAuth: true,
      layout: "Main",
      title: "Profile | Invoices",
    },
  },
  {
    path: "/profile/invoices/:invoiceNumber",
    name: "/profile/invoices/invoiceNumber",
    component: () => import("@/views/profile/InvoicePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "Main",
      title: "Invoice",
    },
  },

  {
    path: "/profile/disputes",
    name: "/profile/disputes",
    component: () => import("@/views/profile/DisputesPage.vue"),
    props: (route) => ({
      params: {
        page: parseInt(route.query.page) || 1,
        status: route.query.status || "OPENED",
      },
    }),
    meta: {
      requiresAuth: true,
      layout: "Main",
      title: "Profile | Disputes",
    },
  },
  {
    path: "/profile/reviews",
    name: "/profile/reviews",
    component: () => import("@/views/profile/ReviewsPage.vue"),
    props: (route) => ({
      params: {
        page: parseInt(route.query.page) || 1,
      },
    }),
    meta: {
      requiresAuth: true,
      layout: "Main",
      title: "Profile | Orders",
    },
  },
  {
    path: "/profile/support",
    name: "/profile/support",
    component: () => import("@/views/profile/SupportPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "Main",
      title: "Profile | Support",
    },
  },
]

export { profile }
